import { render, staticRenderFns } from "./MrBodySize.vue?vue&type=template&id=66fc6284&"
import script from "./MrBodySize.vue?vue&type=script&lang=js&"
export * from "./MrBodySize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports